import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { environment } from '../../../environments/environment';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  // private accessToken = 'IGAATC0l6nU0dBZAE4xLUJNajdrTS16dkJnQXlrOGtEYVRuZAXRkbTJvMnhnTXctSkpFdkc1azhIaUlOM2pTblR6YnVoTFhGb0s0M0ZARa1VmTW5YaXZALSHNLV3J6R2U0U0o3c2l1X0xydFpGNWV4LWNzWHRwTmhwaVdhMTQwNUdmdwZDZD';
  private accessToken = 'IGAATC0l6nU0dBZAGFPdDU0WFM0VVdHejNZAZATNqNWNlYWRJZAWxueEFhdzNSSmJVck5Xc3RfUzFKQjhmVmhyM1ptci1PY1MtRHJvM0NHbURXd09GNktLaVZAEeWZAhWERmSjVXWndrb1ZAFdXFkYURJV1hrX3lSbzkzT1RGYlNwTE1hMAZDZD';
  private apiUrl = `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${this.accessToken}`;
  private facebookDebugTokenUrl = 'https://graph.facebook.com/debug_token';

  private appId = ''; // Reemplaza con tu App ID
  private appSecret = ''; // Reemplaza con tu App Secret

  constructor(private http: HttpClient, private autService: AuthService) { 
    
    // this.testInstagramToken(this.accessToken);
    // this.refreshAccessToken();
  }

  getInstagramImages(): Observable<any> {
    return this.http.get(this.apiUrl);
  }
  getInstagramMediaUrl(MEDIA_ID: any): Observable<any> {
    const url = `https://graph.instagram.com/${MEDIA_ID}/children?fields=id,media_type,media_url&access_token=${this.accessToken}`;
    
    return this.http.get(url).pipe(
      map((response: any) => response?.data?.[0] || null), // Devuelve solo el primer media
      catchError((error) => {
        console.error('Error en la API de Instagram:', error);
        
        let errorMessage = 'Ocurrió un error al obtener los datos de Instagram.';
        
        if (error.status === 400) {
          errorMessage = 'Solicitud incorrecta. Verifica el MEDIA_ID y el token de acceso.';
        } else if (error.status === 401) {
          errorMessage = 'Token de acceso inválido o expirado.';
        } else if (error.status === 403) {
          errorMessage = 'No tienes permisos para acceder a estos datos.';
        } else if (error.status === 404) {
          errorMessage = 'El recurso no fue encontrado. Verifica el MEDIA_ID.';
        } else if (error.status === 500) {
          errorMessage = 'Error interno en el servidor de Instagram. Inténtalo más tarde.';
        }

        return throwError(() => new Error(errorMessage));
      })
    );
  }

  getBannerHome(){
    const url: string = `${environment.URL_SERVER}/banner-home`;

    return this.http.get<boolean>(url, {});
    
  }
  getBannerPopup(){
    const url: string = `${environment.URL_SERVER}/banner-popup`;

    return this.http.get<boolean>(url, {});
    
  }

  getAnalytics(){
    const url: string = `${environment.URL_SERVER}/estadisticas-home`;

    return this.http.get<boolean>(url, {});
    
  }
  getTestimonies(){
    const url: string = `${environment.URL_SERVER}/home-testimonio`;

    return this.http.get<boolean>(url, {});
    
  }

  buscarOportunidad(search: any) {
    const url: string = `${environment.URL_SERVER}/filtro-oportunidades`;

    return this.http.post<boolean>(url, {search});
  }
}
